import { toast } from "react-toastify";

import type { AccountType } from "../../shared/types/accounts";

export const FACEBOOK_LIMITED_GRANT_NOTE =
  "You connected Facebook with only some Pages. If you track Facebook competitors, their follower counts won't show until you reconnect Facebook and choose all Pages.";

/** SKE-5309. Stays up until dismissed: the fix needs another Facebook login. */
export function noteFacebookLimitedGrant(
  account: AccountType | null | undefined
) {
  if (!account?.facebookPageLimitedGrant) {
    return;
  }
  toast.info(FACEBOOK_LIMITED_GRANT_NOTE, {
    autoClose: false,
    toastId: `facebook-limited-grant-${account._id}`,
  });
}
